module.exports = __webpack_public_path__ + "img/portuguese-DE.16b98055.png";